import * as Yup from 'yup'

import { useEffect, useState } from "react"

import { ITimeProps } from './ITimeProps'

export const useTimeValidationSchema = (props: ITimeProps) => {
    const [schema, setSchema] = useState<Yup.StringSchema>();

    useEffect(() => {
        const { label, placeholder, required } = props

        let schema = Yup.string()
        if (required)
            schema = schema.required();

        if (label)
            schema = schema.label(label);
        else if (placeholder)
            schema = schema.label(placeholder);

        const timeRegex = /^(?:2[0-3]|[01][0-9]):[0-5][0-9]$/;
        schema = schema.matches(timeRegex, (p) => `${p.label} field must be a valid time`);

        setSchema(schema)
        // eslint-disable-next-line
    }, [props])

    return schema
}
